import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getMatchHubTeamFactsStyles = (theme: Theme) =>
  StyleSheet.create({
    headerRow: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingBottom: 8,
      marginBottom: 4,
      borderBottomWidth: 1,
      borderBottomColor: theme.gray[200],
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 6,
    },
    homeSide: {
      flex: 1,
      textAlign: 'right',
    },
    awaySide: {
      flex: 1,
      textAlign: 'left',
    },
    teamName: {
      fontSize: 13,
      fontWeight: '700',
      color: theme.gray[800],
    },
    label: {
      width: 96,
      textAlign: 'center',
      fontSize: 11,
      color: theme.gray[500],
      textTransform: 'uppercase',
      letterSpacing: 0.3,
      paddingHorizontal: 6,
    },
    labelSpacer: {
      width: 96,
    },
    value: {
      fontSize: 13,
      fontWeight: '600',
      color: theme.gray[800],
    },
    emptyText: {
      fontSize: 13,
      color: theme.gray[500],
    },
  });
